// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Sonic Universe - Star Systems Configuration
 * 
 * Star systems in the Sonic Universe where speed is life and rings are everywhere.
 */

export const starSystems = [
  {
    id: 2000,
    name: 'Green Hill Zone',
    type: 'system',
    description: 'The iconic starting zone with rolling green hills, loop-de-loops, and golden rings scattered everywhere.',
    threat: 'SAFE',
    resources: 'RINGS, SPEED BOOSTERS',
    services: ['REFUEL', 'REPAIR', 'TRADE'],
    discovered: true,
    primaryColor: '#00FF00',
    secondaryColor: '#0066FF'
  },
  {
    id: 2001,
    name: 'Chemical Plant Zone',
    type: 'system',
    description: 'Industrial complex with pink water and complex pipe systems. Watch out for the rising liquid!',
    threat: 'MODERATE',
    resources: 'INDUSTRIAL MATERIALS, POWER RINGS',
    services: ['REFUEL', 'REPAIR'],
    discovered: false,
    primaryColor: '#FF69B4',
    secondaryColor: '#4169E1'
  },
  {
    id: 2002,
    name: 'Casino Night Zone',
    type: 'system',
    description: 'Neon-lit casino world with pinball mechanics and slot machines. Luck and speed determine your fate.',
    threat: 'MODERATE',
    resources: 'RINGS, BONUS POINTS',
    services: ['TRADE', 'GAMBLING'],
    discovered: false,
    primaryColor: '#FF1493',
    secondaryColor: '#FFD700'
  },
  {
    id: 2003,
    name: 'Sky Sanctuary Zone',
    type: 'system',
    description: 'Ancient floating ruins high in the clouds. Crumbling platforms and mysterious technology.',
    threat: 'HIGH',
    resources: 'ANCIENT TECH, CHAOS ENERGY',
    services: ['RESEARCH'],
    discovered: false,
    primaryColor: '#87CEEB',
    secondaryColor: '#DDA0DD'
  },
  {
    id: 2004,
    name: 'Angel Island Zone',
    type: 'system',
    description: 'Knuckles\' floating island home. Guardian of the Master Emerald and ancient echidna technology.',
    threat: 'HIGH',
    resources: 'MASTER EMERALD ENERGY, GUARDIAN TECH',
    services: ['RESEARCH', 'GUARDIAN TRAINING'],
    discovered: false,
    primaryColor: '#FF4500',
    secondaryColor: '#32CD32'
  }
];

// Star system positions for map visualization
export const starPositions = {
  2000: { x: 50, y: 50, z: 0 },   // Green Hill Zone (center)
  2001: { x: 30, y: 40, z: 2 },   // Chemical Plant Zone
  2002: { x: 70, y: 60, z: 1 },   // Casino Night Zone
  2003: { x: 40, y: 70, z: 3 },   // Sky Sanctuary Zone
  2004: { x: 60, y: 30, z: 4 }    // Angel Island Zone
};